/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Megaphone20 = (props: SVGProps) => (
    <AccessibleSVG width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M12.905 1.868l.083.132 4.746 8.174a2 2 0 01-1.04 2.877l-.142.046-3.552.794V16a3 3 0 01-2.824 2.995L10 19H8a3 3 0 01-2.995-2.824L5 16v-.321l-1.081.243a2 2 0 01-2.196-.787l-.086-.136-1.369-2.4a2 2 0 01.224-2.315l.118-.123 9.256-8.598a2 2 0 013.039.305zM11 14.338l-4 .894V16a1 1 0 00.883.993L8 17h2a1 1 0 00.993-.883L11 16v-1.662zm8.5-7.336a.5.5 0 01.09.992l-.09.008h-2a.5.5 0 01-.09-.992l.09-.008h2zm-.45-3.28a.5.5 0 01-.11.63l-.074.052-1.732 1a.5.5 0 01-.574-.814l.074-.052 1.732-1a.5.5 0 01.683.183zm-2.8-2.715a.5.5 0 01.221.601l-.038.082-1 1.732-.052.074a.5.5 0 01-.852-.492l.038-.082 1-1.732.052-.074a.5.5 0 01.631-.109z"
        />
    </AccessibleSVG>
);

export default Megaphone20;
